// Component disabled - offline functionality removed
export const OfflineIndicator = () => {
  return null;
};
